module.exports = __webpack_public_path__ + "img/rtb_silo_1.291849d6.png";